const lang = document.querySelector("html").getAttribute("lang");
let stockLocales;

import(`Locale/${lang}.json`).then((module) => {
    stockLocales = module.Stock;
});

export const checkMaxStock = (quantity, stock) => {
    quantity = parseFloat(quantity);
    stock = parseFloat(stock);

    if (!stock || stock === 0) {
        return;
    }

    if (quantity > stock) {
        Eshop.alert(stockLocales.exceeded, {
            type: "warning",
        });
    }
};
